import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createErrorAnalytics } from '@jira/polaris__lib-errors/src/createErrorAnalytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { getEditionMeta } from './getEditionMeta.tsx';
import { asyncValues } from '@jira/polaris__lib-ts-utils/src/async-value.tsx';
import type { State, LoadProps } from './PolarisEntitlementStore.types.tsx';

export const loadEditionMeta =
	({ shouldLoad, onLoadingFailed }: LoadProps) =>
	async ({ getState, setState }: StoreActionApi<State>): Promise<void> => {
		if (!fg('jpd_enterprise_edition_support')) {
			return;
		}

		if (!shouldLoad) {
			// We don't need to load the edition meta
			// but at the same time we want to set the state to loaded
			setState({
				editionMeta: asyncValues.loaded(undefined),
			});
			return;
		}

		if (getState().editionMeta.status === 'loading' || getState().editionMeta.status === 'loaded') {
			return;
		}

		setState({
			editionMeta: asyncValues.loading(),
		});

		return getEditionMeta()
			.then((response) => {
				setState({
					editionMeta: asyncValues.loaded(response.edition),
				});
			})
			.catch((error) => {
				fireErrorAnalytics(createErrorAnalytics('getEditionMeta failure', error));
				onLoadingFailed(error);
				setState({
					editionMeta: asyncValues.failed(error),
				});
			});
	};
